module.exports = __webpack_public_path__ + "img/products-3.e8c9927c.png";